import Cookies from 'js-cookie'
import { Base64 } from 'js-base64'
import projectDocuments from "@/assets/img/project_documents.png";
import offeringDocuments from "@/assets/img/offering_documents.png";
import supportDocuments from "@/assets/img/support_documents.png";
import thirdPartyDocuments from "@/assets/img/3rd_party_documents.png";
import otherDocuments from "@/assets/img/other_documents.png";
import docImg from "@/assets/img/doc.png";

export default class Storage {
    static defaultAttributes = {
        secure: true,
        sameSite: 'lax',
        path: '/'
    }

    static get(key, attributes = {}, base64Decode = true) {
        let item = Cookies.get(key, { ...this.defaultAttributes, ...attributes });

        if (item === 'undefined' || item === null) {
            return false;
        }

        if (base64Decode) {
            try {
                item = Base64.decode(item);
            } catch (e) {
            }
        }

        try {
            return JSON.parse(item);
        } catch (e) {
        }

        return item;
    }

    static set(key, value, attributes = {}, base64Encode = true) {
        if (typeof value === "object") {
            value = JSON.stringify(value);
        }

        if (base64Encode) {
            value = Base64.encode(value);
        }

        Cookies.set(key, value, { ...this.defaultAttributes, ...attributes });
    }

    static remove(key, attributes = {}) {
        Cookies.remove(key, attributes);
    }

    static clean(attributes = {}) {
        Object.keys(Cookies.get()).forEach((cookie) => {
            Cookies.remove(cookie, { ...this.defaultAttributes, ...attributes });
        });
    }

    static getTypeIcon(category) {
        if (category == 1) {
            return projectDocuments;
        } else if (category == 2) {
            return offeringDocuments;
        } else if (category == 4) {
            return supportDocuments;
        } else if (category == 5) {
            return thirdPartyDocuments;
        } else if (category == 3) {
            return otherDocuments;
        }
        return docImg;
    }
}
